import semverCompare from 'semver-compare';

export const RELEASE_NOTES_ITEM = 'TACHOGRAPHSERVICES.RELEASENOTES';

export const isNewVersion = (currentVersion: string): boolean => {
    const lastVersion = window.localStorage.getItem(RELEASE_NOTES_ITEM) || '-1';
    return semverCompare(currentVersion, lastVersion) > 0;
};
